import { useNavigate } from 'react-router-dom';
import { SessionTimeout } from '@socialgoodsoftware/components';
import { subscribeToSessionActivity } from '../../lib/session-activity';

function SessionTimeoutWatcher() {
  const navigate = useNavigate();

  const signOut = () => {
    navigate('/logout', { replace: true });
  };

  // Every account response carries the session clock, so the countdown follows the server rather
  // than this tab's own guess. The product hosts have no such stream and simply omit it.
  return <SessionTimeout onExpired={signOut} subscribeToActivity={subscribeToSessionActivity} />;
}

export { SessionTimeoutWatcher };
